import { Box, TextField } from "@mui/material";

const StepOne = ({formData,handleChange}) => {
  return (
    <Box className="mt-3">
      <TextField
        margin="dense"
        label="ID"
        value={formData.id}
        onChange={(e) => handleChange("id", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Title"
        value={formData.title}
        onChange={(e) => handleChange("title", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Light Color"
        value={formData.lightColor}
        onChange={(e) => handleChange("lightColor", e.target.value)}
        fullWidth
      />
      {/* <TextField
        margin="dense"
        label="Dark Color"
        value={formData.darkColor}
        onChange={(e) => handleChange("darkColor", e.target.value)}
        fullWidth
      /> */}
      <TextField
        margin="dense"
        label="DeActive color"
        value={formData.deactiveColor}
        onChange={(e) => handleChange("deactiveColor", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Active color"
        value={formData.activeColor}
        onChange={(e) => handleChange("activeColor", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Size"
        value={formData.size}
        onChange={(e) => handleChange("size", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Top"
        value={formData.top}
        onChange={(e) => handleChange("top", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Left"
        value={formData.left}
        onChange={(e) => handleChange("left", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Index"
        value={formData.index}
        onChange={(e) => handleChange("index", e.target.value)}
        fullWidth
      />
    </Box>
  );
};
export default StepOne;
